import { render } from "./IntroMessageModal2.vue?vue&type=template&id=96c28dd0&scoped=true"
import script from "./IntroMessageModal2.vue?vue&type=script&lang=js"
export * from "./IntroMessageModal2.vue?vue&type=script&lang=js"

import "./IntroMessageModal2.vue?vue&type=style&index=0&id=96c28dd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c28dd0"]])

export default __exports__